import { videoFor } from '../videos';

/**
 * Circled "i" that opens the exercise's demo video.
 *
 * A button rather than an anchor, keeping the app's no-link-text rule, and it
 * opens in a new tab so a workout in progress is never navigated away from —
 * losing your place mid-set to watch a form video would be a poor trade.
 *
 * Renders nothing when the exercise has no video, so callers can drop it in
 * unconditionally.
 */
export default function VideoButton({ exerciseName }: { exerciseName: string }) {
  const url = videoFor(exerciseName);
  if (!url) return null;

  return (
    <button
      type="button"
      className="info-btn info-btn--video"
      aria-label={`Watch a demo of ${exerciseName}`}
      title="Watch the demo video"
      onClick={e => {
        // The row itself may be a button; don't trigger it as well.
        e.stopPropagation();
        window.open(url, '_blank', 'noopener,noreferrer');
      }}
    >
      i
    </button>
  );
}
